var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyBillsSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.001 400V96C21.491 96 0 117.492 0 144V416C0 451.344 28.655 480 64.002 480H496.012C522.523 480 544.013 458.508 544.013 432H80.002C62.328 432 48.001 417.672 48.001 400ZM591.999 32H144.004C117.495 32 96.002 53.492 96.002 80V336C96.002 362.508 117.495 384 144.004 384H591.999C618.511 384 640 362.508 640 336V80C640 53.492 618.511 32 591.999 32ZM367.993 304C323.809 304 287.991 261.02 287.991 208S323.809 112 367.993 112S447.995 154.98 447.995 208S412.178 304 367.993 304Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBillsSimple);
export default __webpack_public_path__ + "static/media/money-bills-simple.cb10b5293c57efe1cdaae262ce0f0394.svg";
export { ForwardRef as ReactComponent };